/**
 * Slick carousel for the ACF component slider informatieblokken
 */

$(window).on('load',function() {
    let slider_container = $('.informatie-slider-grid');
    slider_container.on('init', function(event, slick){
        let width_val = "calc(100% /"+slick.$dots[0].childElementCount+")";
        $(".slider-dots .slick-dots li").css("width", width_val);
        //$(".slick-list").css("overflow", "visible");
    });
    slider_container.slick({
        dots:           true,
        infinite:       false,
        speed:          300,
        slidesToShow:   3,
        slidesToScroll: 1,
        prevArrow: $(".slider-prev"),
        nextArrow: $(".slider-next"),
        appendDots: $(".slider-dots"),
        responsive:     [
          {
            breakpoint: 1310,
            settings:   {
              slidesToShow:   2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings:   {
              slidesToShow:   1,
              slidesToScroll: 1
            }
          }
        ]
    });

    // Fix for give the same height for all the elements inside the carousel
    let maxHeight = 0;
    let thisH = 0;
    $('.informatie-slider-grid .slider-diensten-item')
        .each(function(){
            thisH = $(this).height();
            if (thisH > maxHeight) {
                maxHeight = thisH;
            }
        })
        .height(maxHeight);
});
